const attemptedTokenKey = 'organizationInviteLogoutAttempt';

// A forced logout is attempted once per token: should the session somehow
// survive it, the page would otherwise log out and reload on every reload.
export const hasForcedLogoutBeenAttempted = (token: string) =>
  sessionStorage.getItem(attemptedTokenKey) === token;

export const markForcedLogoutAttempted = (token: string) => {
  sessionStorage.setItem(attemptedTokenKey, token);
};
